import { useMemo } from "react";
import { useQuery } from "react-admin";
import { useFormState } from "react-final-form";
import { get } from "lodash";

const useStats = (userId) => {
  const { values } = useFormState({ subscription: { values: true } });
  const { data, loading } = useQuery({
    type: "get",
    resource: "user-breaks/stats",
    payload: {
      user_id: userId,
    },
  });
  const stats = get(data, "data", null);
  const { totalMonths, wpDuration, contractMonth } = useMemo(() => {
    const contractMonth = get(values, "contract_months", 0);
    const targetFields = ["public_months", "private_months", "foreign_months"];
    const totalMonths = targetFields.reduce((acc, field) => {
      return acc + (values[field] || 0) + (stats?.[field] || 0);
    }, 0);
    const wpDuration = 18 - totalMonths - contractMonth;
    return { totalMonths, wpDuration, contractMonth };
  }, [stats, values]);

  return { totalMonths, wpDuration, contractMonth, loading, stats };
};
export default useStats;
